export default __webpack_public_path__ + "utils/service-worker.js";